import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Asociacion, AsociacionesService, Asociado, AsociadosService, ResponseAsociados } from '../../../api';
import { EncoderService } from '../../services/encoder.service';
import { AlertService } from '../alert/alert.service';
import { BodyRequest, FunctionsAvailable, ItemType, ServiceRequest } from '../formulario/request.model';
import { Observable } from 'rxjs';
import { FieldsForm } from '../formulario/data-fields';
import { environment } from '../../../environments/environment';

type ServiceFunction = (service: ServiceRequest, body: BodyRequest) => Observable<any>;

type ServiceMap = {
  [key: string]: ServiceFunction;
  asociacionesPut: ServiceFunction;
  asociadosPut: ServiceFunction;
};

@Component({
  selector: 'app-update-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './update-password.component.html',
  styleUrl: './update-password.component.scss'
})
export class UpdatePasswordComponent {

  @Input()
  item!: any;

  @Input()
  type!: ItemType;

  @Input()
  functionSelected!: FunctionsAvailable;

  newPassword = new FormControl('');
  newPasswordConfirm = new FormControl('');
  currentPassword = new FormControl('');
  showCurrent = false;
  showNew = false;
  showConfirm = false;

  private servicesMap: {[key: string]: any}  = {
    [ItemType.ASOCIACIONES]: this.asociacionesService,
    [ItemType.ASOCIADOS]: this.asociadosService
  };

  constructor(
    private alertService: AlertService,
    private encoderService: EncoderService,
    private asociadosService: AsociadosService,
    private asociacionesService: AsociacionesService,
    private http: HttpClient
  ) {
    
  }

  checkBody(item: BodyRequest, type: ItemType) {
    for(let key of Object.values(FieldsForm[type])) {
      let value = item[key.name];
      if (key.type === 'number' || key.type === 'select') {
          value = Number(value);
      } else if (key.type === 'checkbox' && value === '') {
          value = false;
      }
      item[key.name] = value;
    }
    return item;
  }

  changePassword() {
    if(!this.currentPassword.value || !this.newPassword.valid || !this.newPasswordConfirm.valid) {
      this.alertService.danger('Repasa los datos del formulario. Existe un error.', 5000);
    } else if (this.newPassword.value !== this.newPasswordConfirm.value) {
      this.alertService.danger('Las contraseñas no coinciden.', 5000);
    } else if (this.newPassword.value === '' || this.newPasswordConfirm.value === '') {
      this.alertService.danger('Existe un error en el formulario, los campos no pueden estar vacíos.', 5000);
    } else {
      if (this.type !== ItemType.ASOCIACIONES) return;
      this.http.post(`${environment.API_BASE_PATH}/asociaciones/password`, { passwordActual: this.encoderService.encrypt(this.currentPassword.value), passwordNueva: this.encoderService.encrypt(this.newPassword.value!) }).subscribe({ next: () => this.alertService.success('Contraseña actualizada.', 4000), error: (err: any) => this.alertService.danger(err.error?.status?.message || 'No se ha podido cambiar la contraseña.', 5000) });

    }
    
  }

}
